import React, { useContext } from "react";

import styles from "./MetaphorsPage.module.css";
import MetaphorSection from "../../components/UserDashboard/MetaphorSection";
import { UserContext } from "../../context/UserContext";

export default function MetaphorsPage() {
  const { userData } = useContext(UserContext);

  function wrapPremium(
    sectionJSX,
    {
      reason = "Conteúdo disponível para o Grupo de Discussão",
      ctaText = "Obtenha acesso agora",
      ctaHref = "/about-group",
    } = {}
  ) {
    if (userData?.entitlements?.groupDiscussion?.active) return sectionJSX;
    // se não tem permissões, retorna o conteúdo borrado com overlay
    return (
      <div style={{ position: "relative" }}>
        <div className={styles.blurredSection} aria-hidden="true">
          {sectionJSX}
        </div>

        <div className={styles.premiumOverlay}>
          <div style={{ padding: 18, textAlign: "center" }}>
            <div style={{ fontWeight: 700, marginBottom: 6 }}>{reason}</div>
            <div style={{ marginBottom: 10, color: "#6b7280" }}>
              {/* Adquira o Relatório Premium para ver o conteúdo completo. */}
            </div>
            <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
              <a className={styles.btnSecondary} href={ctaHref}>
                {ctaText}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1>Metáforas clínicas</h1>
        <p>
          As metáforas abaixo são instrumentos clínicos utilizados em ACT e
          Terapia Baseada em Processos. Cada uma delas deve ser compreendida em
          seu contexto de uso, com indicações e limites claros.
        </p>
      </header>

      {/* =========================
          METÁFORA 1
         ========================= */}
      <section className={styles.metaphorBlock}>
        <h2>Quem guia a sua vida?</h2>

        <MetaphorSection
          wrapPremium={wrapPremium}
          archetypeKey="commander"
          metaphorTitle="Quem guia a sua vida?"
          canViewPremium={userData?.entitlements?.groupDiscussion?.active}
          metaphorDescription="A metáfora dos passageiros no ônibus ilustra a relação entre
              eventos privados difíceis e ação guiada por valores, destacando o
              custo da tentativa de controle excessivo."
          metaphorUses={
            <ul>
              <li>Luta intensa com ansiedade ou pensamentos autocríticos</li>
              <li>Vida organizada em torno de evitar sofrimento</li>
              <li>Inícios de processo terapêutico em ACT</li>
            </ul>
          }
          metaphorProcess={
            <ul>
              <li>Desfusão cognitiva</li>
              <li>Aceitação / abertura experiencial</li>
              <li>Ação guiada por valores</li>
            </ul>
          }
          metaphorRisks={
            <ul>
              <li>Uso moralizante (“basta seguir dirigindo”)</li>
              <li>Minimização do sofrimento</li>
              <li>Aplicação precoce sem vínculo suficiente</li>
            </ul>
          }
        />
      </section>

      {/* =========================
          METÁFORA 2
         ========================= */}
      <section className={styles.metaphorBlock}>
        <h2>O convidado indesejado</h2>

        <MetaphorSection
          wrapPremium={wrapPremium}
          archetypeKey="diplomat"
          metaphorTitle="O convidado indesejado"
          canViewPremium={userData?.entitlements?.groupDiscussion?.active}
          metaphorDescription="Esta metáfora ilustra o custo da luta contínua contra experiências
            internas difíceis e como o controle excessivo pode restringir a
            vida."
          metaphorUses={
            <ul>
              <li>Ciclos persistentes de controle emocional</li>
              <li>Ruminação e hipervigilância</li>
              <li>Exaustão associada à luta interna</li>
            </ul>
          }
          metaphorProcess={
            <ul>
              <li>Aceitação</li>
              <li>Redução da esquiva experiencial</li>
              <li>Contato com o presente</li>
            </ul>
          }
          metaphorRisks={
            <ul>
              <li>Invalidação emocional</li>
              <li>Confundir aceitação com resignação</li>
              <li>Uso em sofrimento agudo intenso</li>
            </ul>
          }
        />
      </section>

      {/* =========================
          METÁFORA 3
         ========================= */}
      <section className={styles.metaphorBlock}>
        <h2>A bússola dos valores</h2>

        <MetaphorSection
          wrapPremium={wrapPremium}
          archetypeKey="navigator"
          metaphorTitle="A bússola dos valores"
          canViewPremium={userData?.entitlements?.groupDiscussion?.active}
          metaphorDescription="A metáfora da bússola dos valores diferencia regras externas de
            valores escolhidos, oferecendo orientação em meio à incerteza."
          metaphorUses={
            <ul>
              <li>Paralisia decisória</li>
              <li>Transições de vida</li>
              <li>Busca excessiva por certeza</li>
            </ul>
          }
          metaphorProcess={
            <ul>
              <li>Contato com valores</li>
              <li>Ação comprometida</li>
              <li>Flexibilidade psicológica</li>
            </ul>
          }
          metaphorRisks={
            <ul>
              <li>Transformar valores em novas regras rígidas</li>
              <li>Uso prescritivo</li>
              <li>Ignorar limitações contextuais reais</li>
            </ul>
          }
        />
      </section>

      <footer className={styles.footer}>
        <p>
          Este material tem finalidade educacional e não substitui psicoterapia,
          supervisão clínica ou formação profissional adequada.
        </p>
      </footer>
    </div>
  );
}
